// TODO: move this file to Wallet Provider once PR is merged

export const useTokenHolders = () => {
  return 13533;
};
